import { Component, OnInit } from '@angular/core';
import {
  FormGroup,
  FormControl,
  Validators,
  FormBuilder,
} from '@angular/forms';
import { AdminService } from '../shared/admin.service';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { take } from 'rxjs/operators';
import { AuthenticationService } from '../shared/authentication.service';
import { CommonService, HttpMethod } from '../services/common.service';
import { ApiCallsService } from '../shared/api-calls.service';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  public loginForm: FormGroup;
private dataArray: any;
  public forgetPasswordEmail = '';
  public showForgetPasswordValidation = false;
  public forgetPasswordValidationText = '';
  public ptype = 'login';
  public passwordmodel: {
    email: string;
    Otp: string;
    Newpwd: string;
    Cnewpwd: string;
  } = { email: '', Otp: '', Newpwd: '', Cnewpwd: '' };
  public optValidation = '';
  public newPasswordValidation = '';
  public cNewPasswordValidation = '';

  constructor(
    private fb: FormBuilder,
    private adminService: AdminService,
    private route: Router,
    private spinner: NgxSpinnerService,
    private toaster: ToastrService,
    private authenticationService: AuthenticationService,
    private commonService: CommonService,
    private global: ApiCallsService
  ) {}

  public ngOnInit(): void {
 document.querySelector("body").classList.remove("move-main-panel");
    this.buildForm();
  }

  private buildForm(): void {
    this.loginForm = this.fb.group({
      Email: ['', Validators.required],
      Password: ['', Validators.required],
    });
  }


  // public signin(): void {
  //   this.spinner.show();
  //   this.adminService
  //     .login({
  //       username: this.loginForm.value.Email,
  //       password: this.loginForm.value.Password,
  //     })
  //     .pipe(take(1))
  //     .subscribe(
  //       (res) => {
  //         console.log(res);
  //         this.dataArray = res;
  //         this.spinner.hide();
  //      //   this.toaster.success('Login success.');
  //         if (this.dataArray.token != null) {
  //           this.authenticationService.logdin(this.dataArray.token);
  //           this.route.navigateByUrl('/dashboard');
  //         } else {
  //           this.toaster.success('Invalid User Name or Password.');
  //         }
  //       },
  //       (err) => {
  //         console.log(err);
  //         this.spinner.hide();
  //         this.toaster.error('Invalid User Name or Password.');
  //       }
  //     );
  // }


  public signin(): void {
    this.spinner.show();
    this.adminService
      .login({
        Email: this.loginForm.value.Email,
        Password: this.loginForm.value.Password,
      }).subscribe((res: any) => {
        this.spinner.hide();
        if (res.statusCode=== 1){
     sessionStorage.setItem('userName', (res.data.userName));
     sessionStorage.setItem('clientId', (res.data.clientId));

          this.authenticationService.logdin(res.data.token);
          this.getCountryPhoneCode(res.data.clientId);
          this.route.navigateByUrl('/dashboard');
        }
        else{
          this.toaster.error('Invalid User Name or Password.');

        }
      }


      );
  }

  getCountryPhoneCode(id) {
    const url = `${this.global.getCountryPhoneCode}?ClientId=${id}`;
    const apiObj = {
      url: url,
      methodType: HttpMethod.GET
    }
    this.commonService.commonApiCall(apiObj, ((res, statusFlag) => {
      if (statusFlag && res && res.hasOwnProperty('data')) {
        localStorage.setItem('countryIds', JSON.stringify(res.data))
      }
      this.route.navigateByUrl('/dashboard');
    }));
  }


  public forgetPasswordClick(): void {
    this.showForgetPasswordValidation = false;
    this.forgetPasswordValidationText = '';
    this.resetPasswordModel();
    const regexEmail = /\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;
    if (this.forgetPasswordEmail.length === 0) {
      this.showForgetPasswordValidation = true;
      this.forgetPasswordValidationText = 'Please Enter Email';
      return;
    }
    if (!this.forgetPasswordEmail.match(regexEmail)) {
      this.showForgetPasswordValidation = true;
      this.forgetPasswordValidationText = 'Please Enter Valid Email';
      return;
    }
    this.spinner.show();
    this.adminService
      .forgetpassword(this.forgetPasswordEmail)
      .pipe(take(1))
      .subscribe(
        (res: any) => {
          this.spinner.hide();
          if (res) {
            this.spinner.hide();
            if (res.status === 1) {
              this.passwordmodel.email = this.forgetPasswordEmail;
              this.forgetPasswordEmail = '';
              this.toaster.success(res.message);
              this.ptype = 'changePassword';
            } else {
              this.showForgetPasswordValidation = true;
              this.forgetPasswordValidationText = res.message;
            }
          }
        },
        (err) => {
          this.spinner.hide();
          // this.toaster.error('Invalid User Name or Password.')
        }
      );
  }

  private resetPasswordModel(): void {
    this.passwordmodel = { email: '', Otp: '', Newpwd: '', Cnewpwd: '' };
    this.resetPasswordValidation();
  }

  private resetPasswordValidation(): void {
    this.optValidation = '';
    this.newPasswordValidation = '';
    this.cNewPasswordValidation = '';
  }

  public resetPasswordClick(): void {
    this.resetPasswordValidation();
    if (this.passwordmodel.Otp === '' || this.passwordmodel.Otp.length === 0) {
      this.optValidation = 'Please Enter OTP';
    } else if (
      this.passwordmodel.Newpwd === '' ||
      this.passwordmodel.Newpwd.length === 0
    ) {
      this.newPasswordValidation = 'Please Enter New Password';
    } else if (
      this.passwordmodel.Cnewpwd === '' ||
      this.passwordmodel.Cnewpwd.length === 0
    ) {
      this.cNewPasswordValidation = 'Please Enter Confirm Password';
    } else if (this.passwordmodel.Newpwd !== this.passwordmodel.Cnewpwd) {
      this.cNewPasswordValidation = 'Password mismatch';
    } else {
      this.spinner.show();
      const data = {
        otp: this.passwordmodel.Otp,
        email: this.passwordmodel.email,
        newpassword: this.passwordmodel.Newpwd,
      };
      this.spinner.show();

      this.adminService
        .SetPassword(data)
        .pipe(take(1))
        .subscribe(
          (res: any) => {
            this.spinner.hide();
            if (res.status === 2) {
              this.toaster.error(res.message);
              return;
            } else {
              this.ptype = 'login';
              this.resetPasswordModel();
              this.toaster.success(res.message);
            }
            //
          },
          (err) => {
            this.spinner.hide();
          }
        );
    }
  }

  public openType(type: string): void {
    this.ptype = type;
    if (type === 'login') {
      this.loginForm.reset();
      return;
    }
    if (type === 'forgetPassword') {
      this.forgetPasswordEmail = '';
      this.showForgetPasswordValidation = false;
      this.forgetPasswordValidationText = '';
    }
    if (type === 'changePassword') {
      this.resetPasswordModel();
    }
  }
}
